var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.15853 0 0 5.15861 0 11.5C0 17.8414 5.15853 23.0001 11.5 23.0001C17.8415 23.0001 23 17.8415 23 11.5001C23 5.15869 17.8414 0 11.5 0ZM18.5692 9.68959L15.042 12.3741L16.4712 17.0069C16.5764 17.3503 16.4466 17.7232 16.1509 17.9269C15.8552 18.1306 15.4609 18.1175 15.1783 17.8941L11.5065 14.9961L7.9103 17.8891C7.76082 18.009 7.57847 18.0699 7.39611 18.0699C7.23678 18.0699 7.07906 18.0239 6.93937 17.9319C6.64034 17.7314 6.50565 17.3618 6.60753 17.0185L7.96944 12.3791L4.43565 9.68967C4.15472 9.47612 4.04136 9.1081 4.15472 8.77295C4.26646 8.43781 4.58019 8.21441 4.93343 8.21441H9.27059L10.7261 3.84768C10.9495 3.1774 12.0618 3.1774 12.2836 3.84768L13.7343 8.21433H18.0714C18.423 8.21433 18.7368 8.43943 18.8501 8.77288C18.9619 9.1064 18.8501 9.47605 18.5692 9.68959Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditStar);
export default __webpack_public_path__ + "static/media/credit_star.06baa38c8cca009938e8ac7fd477b09f.svg";
export { ForwardRef as ReactComponent };